var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrderAndLogistic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6324_106544",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6324_106544)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.07609 17.1525V11.2871L4.11774 8.41693V14.1381C4.11774 14.1808 4.12842 14.2209 4.1498 14.2583C4.17116 14.2957 4.20321 14.3277 4.24594 14.3544L9.07609 17.1525ZM10.1594 17.1525L14.9895 14.3753C15.0323 14.3486 15.0643 14.3165 15.0857 14.2791C15.107 14.2417 15.1177 14.2017 15.1177 14.1589V8.43776L10.1594 11.2871V17.1525ZM8.94786 18.3496L3.7043 15.3063C3.49351 15.1851 3.32917 15.0228 3.21128 14.8196C3.09338 14.6163 3.03442 14.3934 3.03442 14.1509V7.78874C3.03442 7.54624 3.09338 7.32336 3.21128 7.1201C3.32917 6.91682 3.49351 6.75455 3.7043 6.6333L8.94786 3.59005C9.15908 3.46719 9.38283 3.40576 9.61911 3.40576C9.85538 3.40576 10.0782 3.46719 10.2876 3.59005L15.5312 6.6333C15.742 6.75455 15.9063 6.91682 16.0242 7.1201C16.1421 7.32336 16.201 7.54624 16.201 7.78874V14.1509C16.201 14.3934 16.1421 14.6163 16.0242 14.8196C15.9063 15.0228 15.742 15.1851 15.5312 15.3063L10.2876 18.3496C10.0764 18.4725 9.85264 18.5339 9.61636 18.5339C9.3801 18.5339 9.15726 18.4725 8.94786 18.3496ZM12.6642 8.57401L14.7219 7.40253L9.72511 4.54195C9.68237 4.51524 9.63964 4.50189 9.5969 4.50189C9.55417 4.50189 9.51143 4.51524 9.46869 4.54195L7.61772 5.62528L12.6642 8.57401ZM9.61774 10.3352L11.6386 9.17176L6.49274 6.25989L4.51355 7.40253L9.61774 10.3352Z",
    fill: "#1F1F1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderAndLogistic);
export default __webpack_public_path__ + "static/media/order-and-logistic.505d30cdec531477b1b2f7ea614ffcf0.svg";
export { ForwardRef as ReactComponent };